import { User } from '@firebase/auth'
import { SUPER_ADMIN_SESSION_MAX_MS } from 'config'

export const getSuperAdminSessionExpiresAt = (
  authTime: string
): number | undefined => {
  const sessionStart = Date.parse(authTime)

  return Number.isNaN(sessionStart)
    ? undefined
    : sessionStart + SUPER_ADMIN_SESSION_MAX_MS
}

export const isSuperAdminSessionExpired = async (user: User) => {
  const { authTime } = await user.getIdTokenResult()
  const sessionExpiresAt = getSuperAdminSessionExpiresAt(authTime)

  return sessionExpiresAt !== undefined && sessionExpiresAt <= Date.now()
}
